// extracted by mini-css-extract-plugin
export default {"container":"VideoPlayer_container__ltA6c","thumbNail":"VideoPlayer_thumbNail__HOtT7","appear":"VideoPlayer_appear__aK3If","playPause":"VideoPlayer_playPause__iLAQ8"};